/**
 * INTERNATIONALIZATION (i18n) DICTIONARY FOR TESLA PERSONAL BOARD v0.6.1
 */

const STORAGE_KEY_LANG = 'tesla_board_lang';

export const LANGUAGES = [
  { code: 'it', name: 'Italiano 🇮🇹' },
  { code: 'en', name: 'English 🇬🇧' },
  { code: 'es', name: 'Español 🇪🇸' },
  { code: 'fr', name: 'Français 🇫🇷' },
  { code: 'de', name: 'Deutsch 🇩🇪' }
];

export const translations = {
  it: {
    brandTitle: "TESLA BOARD",
    brandSubtitle: "SIMPLE PERSONAL DASHBOARD",
    versionText: "v0.6.1",
    fullscreenOn: "Fullscreen: ON",
    fullscreenOff: "Fullscreen: OFF",
    themeAuto: "Auto (Sistema)",
    themeDark: "Scuro",
    themeLight: "Chiaro",
    btnManagePresets: "Servizi Predefiniti",
    btnNewLink: "Nuovo Link",
    btnCancel: "Annulla",
    btnSave: "Salva Link",
    btnDelete: "Elimina Link",
    btnDone: "Fatto",
    btnExport: "Esporta JSON",
    btnImport: "Importa JSON",
    btnResetDefault: "Ripristina Catalogo Iniziale",
    btnAddCustomCat: "+ Nuova Categoria...",
    searchPlaceholder: "Cerca app, servizi, segnalibri...",
    sortCategory: "Per Categoria",
    sortAZ: "Titolo (A - Z)",
    sortZA: "Titolo (Z - A)",
    catAll: "Tutti i Link",
    catFavorites: "Preferiti",
    catSmarthome: "Smart Home",
    catSocial: "Social",
    catStreaming: "Streaming Video",
    catLivetv: "Live TV",
    catSports: "Sport",
    catAuto: "Auto & Mappe",
    catUtilities: "Utility & IA",
    catGames: "Giochi",
    catVm18: "VM18",
    weatherLoading: "Caricamento...",
    modalAddTitle: "Aggiungi Nuovo Link",
    modalEditTitle: "Modifica Link",
    modalEditPresetNotice: "Nota: Stai modificando un servizio predefinito. Verrà creata automaticamente una tua copia personalizzata.",
    formTitle: "Titolo Servizio / App *",
    formUrl: "URL Principale *",
    urlHelp: "Puoi inserire URL completi con percorsi ed estensioni. I pulsanti in alto aggiungono il prefisso automaticamente.",
    formCategory: "Categoria",
    formCustomRedirect: "URL Redirect Fullscreen Personalizzato (Opzionale)",
    formLogoSquare: "URL Logo Quadrato (Opzionale)",
    formLogoWide: "URL Logo Esteso/Banner (Opzionale)",
    formColorLabel: "Colore Sfondo App & Tavolozza Rapida",
    formIconFallback: "Nome Icona Lucide (Fallback)",
    formColorPicker: "Selettore Colore Custom",
    presetsModalTitle: "Gestione Servizi Predefiniti per Categoria",
    presetsModalSubtitle: "Espandi le categorie per attivare o disattivare i servizi di sistema out-of-the-box o aggiungerli ai preferiti.",
    settingsTitle: "Impostazioni & Temi Dashboard",
    selectLang: "Lingua Interfaccia",
    themePresetDark: "Preset Tema Scuro",
    themePresetLight: "Preset Tema Chiaro",
    catOrderTitle: "Ordinamento & Visibilità Categorie Dashboard",
    catOrderSubtitle: "Sposta le categorie per personalizzarne la sequenza ed attiva/disattiva la visibilità nella GUI",
    toggleAnimatedBg: "Sfondo Animato Dinamico",
    backupRestore: "Backup & Manutenzione Dati",
    toastLinkSaved: "Link salvato con successo!",
    toastLinkDeleted: "Link eliminato con successo!",
    toastImportSuccess: "Configurazione importata con successo!",
    toastResetSuccess: "Dashboard ripristinata al catalogo iniziale!"
  },
  en: {
    brandTitle: "TESLA BOARD",
    brandSubtitle: "SIMPLE PERSONAL DASHBOARD",
    versionText: "v0.6.1",
    fullscreenOn: "Fullscreen: ON",
    fullscreenOff: "Fullscreen: OFF",
    themeAuto: "Auto (System)",
    themeDark: "Dark",
    themeLight: "Light",
    btnManagePresets: "Preset Services",
    btnNewLink: "New Link",
    btnCancel: "Cancel",
    btnSave: "Save Link",
    btnDelete: "Delete Link",
    btnDone: "Done",
    btnExport: "Export JSON",
    btnImport: "Import JSON",
    btnResetDefault: "Reset to Default",
    btnAddCustomCat: "+ New Category...",
    searchPlaceholder: "Search apps, services, bookmarks...",
    sortCategory: "By Category",
    sortAZ: "Title (A - Z)",
    sortZA: "Title (Z - A)",
    catAll: "All Links",
    catFavorites: "Favorites",
    catSmarthome: "Smart Home",
    catSocial: "Social",
    catStreaming: "Video Streaming",
    catLivetv: "Live TV",
    catSports: "Sports",
    catAuto: "Auto & Maps",
    catUtilities: "Utility & AI",
    catGames: "Games",
    catVm18: "18+ Adult",
    weatherLoading: "Loading...",
    modalAddTitle: "Add New Link",
    modalEditTitle: "Edit Link",
    modalEditPresetNotice: "Note: You are editing a default service. A custom copy will be created automatically.",
    formTitle: "Service / App Title *",
    formUrl: "Main URL *",
    urlHelp: "You can enter full URLs with paths and parameters. The buttons above add prefix automatically.",
    formCategory: "Category",
    formCustomRedirect: "Custom Fullscreen Redirect URL (Optional)",
    formLogoSquare: "Square Logo URL (Optional)",
    formLogoWide: "Wide/Banner Logo URL (Optional)",
    formColorLabel: "App Background Color & Quick Swatches",
    formIconFallback: "Lucide Icon Name (Fallback)",
    formColorPicker: "Custom Color Picker",
    presetsModalTitle: "Manage Preset Services by Category",
    presetsModalSubtitle: "Expand categories to activate/deactivate system services out-of-the-box or add to favorites.",
    settingsTitle: "Dashboard Settings & Themes",
    selectLang: "Interface Language",
    themePresetDark: "Dark Theme Preset",
    themePresetLight: "Light Theme Preset",
    catOrderTitle: "Dashboard Category Ordering & Visibility",
    catOrderSubtitle: "Reorder categories or toggle their visibility on the dashboard GUI",
    toggleAnimatedBg: "Dynamic Animated Background",
    backupRestore: "Backup & Data Maintenance",
    toastLinkSaved: "Link saved successfully!",
    toastLinkDeleted: "Link deleted successfully!",
    toastImportSuccess: "Configuration imported successfully!",
    toastResetSuccess: "Dashboard reset to initial catalog!"
  },
  es: {
    brandTitle: "TESLA BOARD",
    brandSubtitle: "SIMPLE PERSONAL DASHBOARD",
    versionText: "v0.6.1",
    fullscreenOn: "Fullscreen: ON",
    fullscreenOff: "Fullscreen: OFF",
    themeAuto: "Auto (Sistema)",
    themeDark: "Oscuro",
    themeLight: "Claro",
    btnManagePresets: "Servicios Predeterminados",
    btnNewLink: "Nuevo Enlace",
    btnCancel: "Cancelar",
    btnSave: "Guardar Enlace",
    btnDelete: "Eliminar Enlace",
    btnDone: "Hecho",
    btnExport: "Exportar JSON",
    btnImport: "Importar JSON",
    btnResetDefault: "Restablecer Inicio",
    btnAddCustomCat: "+ Nueva Categoría...",
    searchPlaceholder: "Buscar aplicaciones, servicios...",
    sortCategory: "Por Categoría",
    sortAZ: "Título (A - Z)",
    sortZA: "Título (Z - A)",
    catAll: "Todos los Enlaces",
    catFavorites: "Favoritos",
    catSmarthome: "Smart Home",
    catSocial: "Social",
    catStreaming: "Streaming Vídeo",
    catLivetv: "Live TV",
    catSports: "Deportes",
    catAuto: "Auto y Mapas",
    catUtilities: "Utilidades e IA",
    catGames: "Juegos",
    catVm18: "18+ Adultos",
    weatherLoading: "Cargando...",
    modalAddTitle: "Añadir Nuevo Enlace",
    modalEditTitle: "Editar Enlace",
    modalEditPresetNotice: "Nota: Estás editando un servicio predeterminado.",
    formTitle: "Título del Servicio *",
    formUrl: "URL Principal *",
    urlHelp: "Puedes introducir URLs completas.",
    formCategory: "Categoría",
    formCustomRedirect: "URL Redirect Pantalla Completa",
    formLogoSquare: "URL Logo Cuadrado",
    formLogoWide: "URL Logo Banner",
    formColorLabel: "Color de Fondo de la App",
    formIconFallback: "Nombre de Icono Lucide",
    formColorPicker: "Selector de Color",
    presetsModalTitle: "Gestión de Servicios Predeterminados",
    presetsModalSubtitle: "Activa o desactiva servicios predeterminados.",
    settingsTitle: "Ajustes y Temas",
    selectLang: "Idioma de la Interfaz",
    themePresetDark: "Tema Oscuro",
    themePresetLight: "Tema Claro",
    catOrderTitle: "Orden y Visibilidad de Categorías",
    catOrderSubtitle: "Organiza las categorías de tu dashboard",
    toggleAnimatedBg: "Fondo Animado Dinámico",
    backupRestore: "Mantenimiento de Datos",
    toastLinkSaved: "¡Enlace guardado con éxito!",
    toastLinkDeleted: "¡Enlace eliminado con éxito!",
    toastImportSuccess: "¡Configuración importada con éxito!",
    toastResetSuccess: "¡Dashboard restablecido!"
  },
  fr: {
    brandTitle: "TESLA BOARD",
    brandSubtitle: "SIMPLE PERSONAL DASHBOARD",
    versionText: "v0.6.1",
    fullscreenOn: "Plein Écran: ON",
    fullscreenOff: "Plein Écran: OFF",
    themeAuto: "Auto (Système)",
    themeDark: "Sombre",
    themeLight: "Clair",
    btnManagePresets: "Services Prédéfinis",
    btnNewLink: "Nouveau Lien",
    btnCancel: "Annuler",
    btnSave: "Enregistrer Lien",
    btnDelete: "Supprimer Lien",
    btnDone: "Terminé",
    btnExport: "Exporter JSON",
    btnImport: "Importer JSON",
    btnResetDefault: "Réinitialiser",
    btnAddCustomCat: "+ Nouvelle Catégorie...",
    searchPlaceholder: "Rechercher des applications...",
    sortCategory: "Par Catégorie",
    sortAZ: "Titre (A - Z)",
    sortZA: "Titre (Z - A)",
    catAll: "Tous les Liens",
    catFavorites: "Favoris",
    catSmarthome: "Maison Connectée",
    catSocial: "Réseaux Sociaux",
    catStreaming: "Streaming Vidéo",
    catLivetv: "Live TV",
    catSports: "Sports",
    catAuto: "Auto & Cartes",
    catUtilities: "Utilitaires & IA",
    catGames: "Jeux",
    catVm18: "18+ Adulte",
    weatherLoading: "Chargement...",
    modalAddTitle: "Ajouter un Nouveau Lien",
    modalEditTitle: "Modifier le Lien",
    modalEditPresetNotice: "Note: Vous modifiez un service par défaut.",
    formTitle: "Titre du Service *",
    formUrl: "URL Principale *",
    urlHelp: "Vous pouvez entrer des URL complètes.",
    formCategory: "Catégorie",
    formCustomRedirect: "URL Redirection Plein Écran",
    formLogoSquare: "URL Logo Carré",
    formLogoWide: "URL Logo Bannière",
    formColorLabel: "Couleur de Fond",
    formIconFallback: "Nom d'Icône Lucide",
    formColorPicker: "Sélecteur de Couleur",
    presetsModalTitle: "Gestion des Services Prédéfinis",
    presetsModalSubtitle: "Activez ou désactivez les services par défaut.",
    settingsTitle: "Paramètres & Thèmes",
    selectLang: "Langue de l'Interface",
    themePresetDark: "Thème Sombre",
    themePresetLight: "Thème Clair",
    catOrderTitle: "Ordre et Visibilité des Catégories",
    catOrderSubtitle: "Organisez les catégories du tableau de bord",
    toggleAnimatedBg: "Fond Animé Dynamique",
    backupRestore: "Maintenance des Données",
    toastLinkSaved: "Lien enregistré avec succès!",
    toastLinkDeleted: "Lien supprimé avec succès!",
    toastImportSuccess: "Configuration importée avec succès!",
    toastResetSuccess: "Tableau de bord réinitialisé!"
  },
  de: {
    brandTitle: "TESLA BOARD",
    brandSubtitle: "SIMPLE PERSONAL DASHBOARD",
    versionText: "v0.6.1",
    fullscreenOn: "Vollbild: ON",
    fullscreenOff: "Vollbild: OFF",
    themeAuto: "Auto (System)",
    themeDark: "Dunkel",
    themeLight: "Hell",
    btnManagePresets: "Vordefinierte Dienste",
    btnNewLink: "Neuer Link",
    btnCancel: "Abbrechen",
    btnSave: "Link Speichern",
    btnDelete: "Link Löschen",
    btnDone: "Fertig",
    btnExport: "JSON Exportieren",
    btnImport: "JSON Importieren",
    btnResetDefault: "Zurücksetzen",
    btnAddCustomCat: "+ Neue Kategorie...",
    searchPlaceholder: "Apps und Dienste suchen...",
    sortCategory: "Nach Kategorie",
    sortAZ: "Titel (A - Z)",
    sortZA: "Titel (Z - A)",
    catAll: "Alle Links",
    catFavorites: "Favoriten",
    catSmarthome: "Smart Home",
    catSocial: "Soziale Medien",
    catStreaming: "Video Streaming",
    catLivetv: "Live TV",
    catSports: "Sport",
    catAuto: "Auto & Karten",
    catUtilities: "Dienstprogramme & KI",
    catGames: "Spiele",
    catVm18: "18+ Erwachsenen",
    weatherLoading: "Laden...",
    modalAddTitle: "Neuen Link Hinzufügen",
    modalEditTitle: "Link Bearbeiten",
    modalEditPresetNotice: "Hinweis: Sie bearbeiten einen Standarddienst.",
    formTitle: "Diensttitel *",
    formUrl: "Haupt-URL *",
    urlHelp: "Sie können vollständige URLs eingeben.",
    formCategory: "Kategorie",
    formCustomRedirect: "Vollbild-Umleitungs-URL",
    formLogoSquare: "Quadratische Logo-URL",
    formLogoWide: "Banner Logo-URL",
    formColorLabel: "Hintergrundfarbe der App",
    formIconFallback: "Lucide Symbolname",
    formColorPicker: "Benutzerdefinierter Farbwähler",
    presetsModalTitle: "Verwaltung Vordefinierter Dienste",
    presetsModalSubtitle: "Aktivieren oder deaktivieren Sie Standarddienste.",
    settingsTitle: "Einstellungen & Themen",
    selectLang: "Schnittstellensprache",
    themePresetDark: "Dunkles Thema",
    themePresetLight: "Helles Thema",
    catOrderTitle: "Reihenfolge & Sichtbarkeit der Kategorien",
    catOrderSubtitle: "Organisieren Sie Ihre Dashboard-Kategorien",
    toggleAnimatedBg: "Dynamischer Animierter Hintergrund",
    backupRestore: "Datenwartung",
    toastLinkSaved: "Link erfolgreich gespeichert!",
    toastLinkDeleted: "Link erfolgreich gelöscht!",
    toastImportSuccess: "Konfiguration erfolgreich importiert!",
    toastResetSuccess: "Dashboard zurückgesetzt!"
  }
};

let currentLang = localStorage.getItem(STORAGE_KEY_LANG) || 'it';

export function getLanguage() {
  return currentLang;
}

export function setLanguage(lang) {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem(STORAGE_KEY_LANG, lang);
    applyTranslations();
  }
}

export function t(key) {
  return (translations[currentLang] && translations[currentLang][key]) || 
         (translations['it'] && translations['it'][key]) || key;
}

export function applyTranslations() {
  const elements = document.querySelectorAll('[data-i18n]');
  elements.forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (key) {
      if (el.tagName === 'INPUT' && el.hasAttribute('placeholder')) {
        el.placeholder = t(key);
      } else {
        el.textContent = t(key);
      }
    }
  });
}

export function updateDOMTranslations() {
  applyTranslations();
}
